import { css } from '@emotion/react'
import { memo } from 'react'
import i18n from '../../utilities/i18n'
import { getThemeSpacing } from '../styles/appTheme'
import { palette } from '../styles/colors'
import Button from './Button'

const rootStyles = css({
    padding: `${getThemeSpacing(0.5)} ${getThemeSpacing(1.5)}`,
    backgroundColor: palette.backgroundRaised,
    whiteSpace: 'pre',
})

interface IButtonInsertDate {
    onClick?(event?: any): any
}

const ButtonInsertDate = memo((props: IButtonInsertDate) => {
    const { onClick } = props
    const label = i18n.t('buttons.insertDate')

    return (
        <Button
            onClick={onClick}
            data-testid="Button__InsertDate"
            css={rootStyles}
            clean
        >
            {label}
        </Button>
    )
})

export default ButtonInsertDate
